import { createContext } from "react"



const usersDataContext = createContext({})



export default usersDataContext